import React, { useState } from 'react'
import bulkDisburseImage from '../../../../images/bulkDisburseImage.jpeg'
import { UploadBulkTranscationLeads } from '../AdminActionCreator.component'
import Loader from '../../../presentationals/Loader/Loader.component'
import Popup from '../../../presentationals/Popup/Popup.component'
export default function BulkDisburseNew(admin) {
    const [loader, setLoader] = useState(false)
    const [popup, setpopup] = useState({ show: false, popupStatus: "" })
    const [nbfc, setNbfc] = useState("")
    const [file, setFile] = useState('')
    const [errorData, setErrorData] = useState([])

    const handleFile = (e) => {
        setFile(e.target.files?.[0])
    }

    const handleUpload = () => {
        let imageFormData = new FormData()
        imageFormData.append('file', file)
        imageFormData.append('empId', admin?.emailId)
        imageFormData.append('nbfcName', nbfc)
        setLoader(true)
        UploadBulkTranscationLeads(imageFormData, callback => {
            setLoader(false)
            if (callback?.status == 200 && callback?.message == "success" && (callback?.data?.length == 0 || callback?.data == null || callback?.data == undefined)) {
                setpopup({ show: true, popupStatus: "Data Uploaded Successfully!" })
            } else if (callback?.status == 200 && callback?.message == "success" && callback?.data?.length > 0) {
                setErrorData(callback?.data ?? [])
            } else {
                setpopup({ show: true, popupStatus: "Error Uploading Data!" })
            }
            setTimeout(() => {
                closePopup()
            }, 4000)
        })
    }

    const closePopup = () => {
        setpopup({ show: false, popupStatus: "" })
    }
    return (
        <>
            {loader ? <Loader /> : ""}
            {popup?.show ? <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} /> : ""}
            <div className="container-fluid">
                <div className="row">
                    <h3 class="text-center blue-text">Bulk Disburse</h3>
                </div>
                <div className="row" style={{ marginTop: '20px' }}>
                    <div className="col-sm-4"></div>
                    <div className="col-sm-4 col-xs-12">
                        <div>
                            <label>Select NBFC</label>
                            <select
                                onChange={(e) => setNbfc(e.target.value)}
                                value={nbfc}
                                className='form-control'
                            >
                                <option value={""}>Select Option</option>
                                <option value={"ev"}>EV</option>
                                <option value={"dmi"}>DMI</option>
                            </select>
                        </div>

                        {
                            nbfc !== "" ?
                                <div>
                                    {/* <img src={bulkDisburseImage} width={"100%"}/> */}

                                    <div className="image-upload-wrap" style={{ height: '200px' }}>
                                        <input type='file' accept={['.xlx', '.xlxs', '.xlsx', '.xls']} class="file-upload-input" onChange={(e) => handleFile(e)} />
                                    </div>

                                    <div style={{ marginTop: '20px', textAlign: 'center' }}>
                                        <button className='btn btn-primary' onClick={() => handleUpload()}>
                                            Upload
                                        </button>
                                    </div>
                                </div>
                                : ""}
                    </div>
                    <div className="col-sm-4"></div>
                </div>

                {
                    errorData && errorData?.length > 0 ?

                        <div className="row" style={{ marginTop: '20px' }}>
                            <div className="col-sm-2"></div>
                            <div className="col-sm-8 col-xs-12">
                                <div
                                    style={{
                                        boxShadow: "3px 3px 3px 3px #eee",
                                        borderRadius: "8px",
                                        padding: "10px"
                                    }}>
                                    <h5>Error Logs</h5>

                                    <div className='overflow-x-auto phocket-table-new'>
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>S.No.</th>
                                                    <th>Data</th>
                                                    <th>Reason</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    errorData?.length > 0 ? errorData?.map((val, id) => {
                                                        return (
                                                            <tr key={id}>
                                                                <td>{id + 1}</td>
                                                                <td>{val?.value ?? ""}</td>
                                                                <td>{val?.reason ?? ""}</td>
                                                            </tr>
                                                        )
                                                    })
                                                        : ""}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-2"></div>
                        </div>
                        : ""}
            </div>
        </>
    )
}
